import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ServiceAreasServiceType} from "../../../service-areas/angular/types/service-areas-service.type";
import {CommonsService} from "../../services/commons-service.service";

export class bringozServiceAreaMultiSelectListCtrl implements IController {
  selectedIds: any;
  optionIds: any;
  branchIds: any;
  accountIds: any;
  serviceTypes: ServiceAreasServiceType[];
  excludeIds?: string[];
  noArea: boolean;
  noPickUpArea: boolean;
  noDropOffArea: boolean;
  ngPlaceholder: any;
  selectAllOnInit: boolean;
  onChange: Function;
  onChangeFilterNoArea: Function;
  onChangeFilterNoPickUpArea: Function;
  onChangeFilterNoDropOffArea: Function;


  private serviceAreasRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private selectedKeys: any;
  public noAreaEnabled: boolean;
  public excludedMap: any;
  public isSelectAll: boolean;
  public tags: string[] = [];
  public subFilterQueryMap: any;

  /* @ngInject */
  constructor(private $serviceArea, private $infiniteScroll, private $log, private commonsService: CommonsService) {
  }

  $onInit() {
    this.serviceAreasRef = this.$serviceArea();
    this.loadLimit = 30;

    this.serviceAreasRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.serviceAreasRef, this.loadLimit, {getFullData: true});

    if (!_.isUndefined(this.noArea)) {
      this.noAreaEnabled = true;
    }

    this.subFilterQueryMap = {
      tagType: 'Area'
    }
  }

  $onChanges(changes) {
    if (changes.selectedIds) {
      this.selectedKeys = [];
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      })
    }

    if (changes.branchIds && !changes.branchIds.isFirstChange()) {
      this.$onInit();
    }

    if (changes.excludeIds) {
      this.excludedMap = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludedMap[id] = true;
      })
    }

  }

  onToggle(serviceAreaId, isSelected) {
    this.onChange({
      areaIds: isSelected ? _.concat(this.selectedIds || [], [serviceAreaId]) :
        _.filter(this.selectedIds, (id) => {
          return id !== serviceAreaId;
        })
    });
  }

  onToggleFilterNoArea(isSelected) {
    this.onChangeFilterNoArea({isEnabled: isSelected});
  }

  onToggleFilterNoPickUpArea() {
    this.onChangeFilterNoPickUpArea({isEnabled: !this.noPickUpArea});
  }

  onToggleFilterNoDropOffArea() {
    this.onChangeFilterNoDropOffArea({isEnabled: !this.noDropOffArea});
  }

  submitQuery(query) {
    this.queryString = query;
    if (!this.optionIds) {
      this._reload();
    } else {
      this._search();
    }
  }

  setSelectedOnInit() {
    if (!!this.selectAllOnInit) {
      this.selectAllOnInit = false
      const areasToSelect = this.infiniteScroll.getItems();
      if (areasToSelect.length && areasToSelect.length < this.loadLimit) {
        this.onChange({areaIds: _.map(areasToSelect, 'id')});
      }
    }
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onChange({areaIds: []});
    } else {
      this.onChange({areaIds: this.infiniteScroll?.getItems()?.map((area) => area.id)});
    }
  }

  isAllSelected() {
    this.isSelectAll = this.commonsService.checkIfArraysMatch(this.infiniteScroll?.getItems().map(area => area.id), this.selectedIds);
    return this.isSelectAll;
  }

  onChangeFilters(tags) {
    this.tags = tags;
    this._reload();
  }

  private _reload() {
    this.serviceAreasRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _search() {
    this.infiniteScroll.search(this.queryString);
  }

  private _getQueryPayload() {
    return {
      ids: this.optionIds,
      limit: this.loadLimit,
      query: this.queryString,
      accountIds: this.accountIds,
      branchIds: this.branchIds,
      serviceTypes: this.serviceTypes,
      tags: this.tags,
      sort: 'areaName,asc'
    };
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozServiceAreaMultiSelectList', {
    bindings: {
      selectedIds: '<?',
      optionIds: '<?',
      branchIds: '<?',
      accountIds: '<?',
      serviceTypes: '<?',
      excludeIds: '<?',
      isNoAreaEnabled: '<?',
      isPickupEnabled: '<?',
      isDropoffEnabled: '<?',
      noArea: '<?',
      noPickUpArea: '<?',
      noDropOffArea: '<?',
      noUnderline: '@?',
      ngPlaceholder: '@?',
      selectAllOnInit: '<?',
      onChange: '&',
      onChangeFilterNoArea: '&',
      onChangeFilterNoPickUpArea: '&',
      onChangeFilterNoDropOffArea: '&',
    },
    template: require('./bringoz-service-area-multi-select-list.html').default,
    controller: bringozServiceAreaMultiSelectListCtrl
  });
